export default [
  {
    text: 'Организации',
    to: { name: 'organizations' },
    ico: 'org',
  },
];



// WEBPACK FOOTER //
// ./src/pages/menu.organizations.js